import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/CustomEase";
import { $qs, $qsa } from '../utils/QuerySelector';
import { media } from '../utils/MediaQueries';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


function homeContentSlider() {

  let sliderContent = $('.content-slider__content');
  sliderContent.slick({
    dots: true,
    arrows: true,
    fade: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 8000,
    speed: 2000,
    pauseOnHover: false,
    focusOnSelect: false,
    accessibility: false,
    asNavFor: '.content-slider__images',
    prevArrow: sliderContent.parent().parent().find('.slider-nav__prev'),
    nextArrow: sliderContent.parent().parent().find('.slider-nav__next'),
    appendDots: sliderContent.parent().parent().find('.slider-dots-container')
  });
  
  let sliderImages = $('.content-slider__images');
  sliderImages.slick({
    dots: false,
    arrows: false,
    fade: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 8000,
    speed: 2000,
    pauseOnHover: false,
    focusOnSelect: false,
    accessibility: false,
    asNavFor: '.content-slider__content',
  });
  

  
  if (media.lg) return;

  sliderImages.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    let currentSlideImage = $('.slide-images [data-slick-index='+currentSlide+']');
    let nextSlideImage    = $('.slide-images [data-slick-index='+nextSlide+']');

    gsap.set( currentSlideImage, { zIndex: 9 } )
    gsap.set( nextSlideImage, { zIndex: 8 } )

    // Create a timeline
    let tl = gsap.timeline({
		defaults: {
			duration: 3,
			ease: "none" 
		},
		smoothChildTiming: true,
		autoRemoveChildren: true,
		});

		tl.to(currentSlideImage, {
			xPercent: 110,
			rotation: -3,
			ease:'power1.easeInOut',
			duration: 1.2
		} )
		tl.to(currentSlideImage, {
			xPercent: 0,
			rotation: 0,
			zIndex: 1,
			ease:'power1.easeInOut',
			duration: 1
		} )

	});


	sliderImages.on('afterChange', function(slick, currentSlide){
		let lastSlideMoved = currentSlide.currentSlide - 1
		if ( lastSlideMoved < 0 ) {
			lastSlideMoved = slick.currentTarget.slick.slideCount - 1
		}

		let lastSlideToBeMoved = $( '.content-slider__images .slick-slide[data-slick-index=' + lastSlideMoved + ']' );
		let rotationWanted     = ( lastSlideMoved % 2 ? '-3' : '3' )
		gsap.to( lastSlideToBeMoved, { opacity: 1, zIndex: 1, xPercent: 0, rotation: rotationWanted } )
	})

}

export default homeContentSlider;
